import Debug from 'debug'
import Vue from 'vue';
import VueRouter, { RouteConfig, Route, RouterMode } from 'vue-router';
import { resolve } from '@/app/container';
import {
  SectionNavigationService,
  SectionNavigationServiceSymbol
} from '@/app/statistics/section/section-navigation-service';
import { getPageLocationByHref } from '@/app/shared/utils/route-utils';
import { LayoutService, LayoutServiceSymbol } from '@/app/layout/layout-service';
//import quizSessionStoreModule from '@/app/quiz/state/quiz-session-state';

const debug = Debug('router')

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: '/',
    name: 'default',
    component: () => import('@/app/layout/components/layout-component.vue'),

    async beforeEnter(to: Route, from: Route, next) {
      debug('beforeEnter', to, from, )

      if (to.name === 'default' || (to.name === 'oldPage' && !to.params.page)) {
        debug('default page, determine default location')
        const layoutService = resolve<LayoutService>(LayoutServiceSymbol);
        const initialLocation = await layoutService.resolveToStartingPageLocation()
        debug('initial location', initialLocation)

        // replace the empty 'default' route
        next({...initialLocation, replace: true})
      } else {
        debug('non-default page, go to the requested location', to)
        next()
      }
    },
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/app/dashboard/components/dashboard-component.vue')
      },
      {
        path: 'course',
        name: 'course',
        component: () => import('@/app/presenter/components/course-layout-component.vue'),
        children: [
          {
            path: ':page?',
            name: 'page',
            component: () => import('@/app/presenter/components/presenter-component.vue'),
            props: true
          }
        ]
      },
      {
        path: 'search',
        name: 'search',
        component: () => import('@/app/search/components/search-page-component.vue')
      },
      {
        path: ':page?',
        name: 'oldPage',
        beforeEnter(to: Route, from: Route, next: any) {
          debug('oldPage beforeEnter', to, from)
          if (to.params.page) {
            const nextLocation = getPageLocationByHref(to.params.page)
            debug('oldPage redirecting to', nextLocation)
            next(nextLocation);
          } else {
            next();
          }
        }
      },
      {
        path: '404-not-found.html',
        name: 'notFound',
        component: () => import('@/app/shared/components/not-found-component.vue')
      }
    ]
  }
];


// this variable is set from the index.html
type UrlMode = 'hash' | 'classic'
declare global {
  interface Window {
    urlModeConfig?: UrlMode
  }
}

function mapToRouterMode(urlMode: UrlMode): RouterMode {
  switch (urlMode) {
    case 'hash':
      return 'hash'
    case 'classic':
      return 'history'
    default:
      return 'hash'
  }
}

const urlMode: UrlMode = window.urlModeConfig || 'hash'
const routerMode = mapToRouterMode(urlMode)

debug(`requested router mode is ${window.urlModeConfig}; final router mode: ${routerMode} `)
const router = new VueRouter({
  mode: routerMode,
  routes
});

router.beforeEach((to: Route, from: Route, next: any) => {
  const navigateFromPageAway: boolean = from.name === 'page' && to.name !== 'page';
  if (navigateFromPageAway) {
    const service = resolve<SectionNavigationService>(SectionNavigationServiceSymbol);
    service.closeSectionIfNecessary();
  }

  // if (quizSessionStoreModule.inProgress) {
  //   const eventStream: EventStream = resolve<EventStream>(EventStreamSymbol);
  //   eventStream.dispatch({
  //     name: BeforeNavigateFromQuizEventName,
  //     payload: {
  //       title: 'TODO'
  //     }
  //   });
  // } else {
  //   next();
  // }
  next();
});

export default router;
